import { render, staticRenderFns } from "./PageSizeSelector.vue?vue&type=template&id=ec256ff2&"
import script from "./PageSizeSelector.vue?vue&type=script&lang=ts&"
export * from "./PageSizeSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports